<template>
  <div :class="$style.loadingPage">
    <LoadingBoxMobile :class="$style.loadingBoxMobile" />
    <!-- <div :class="$style.footerLogo">
      <img src="@/assets/footer_logo.svg" />
    </div> -->
  </div>
</template>

<script>
import { LoadingBoxMobile } from '@/components/LoadingBox'

export default {
  name: 'LoadingPage',
  components: { LoadingBoxMobile }
}
</script>

<style lang="scss" module>
.loadingPage {
  display: flex;
  align-items: center;
  height: 100%;
}

.loadingBoxMobile {
  position: static;
  box-shadow: none;
}

.footerLogo {
  position: absolute;
  bottom: 33px;
  text-align: center;
  width: 100%;

  img {
    width: 78px;
    height: 22px;
  }
}
</style>
